export default __webpack_public_path__ + "static/media/click.79d3f0a2.svg";